const o = {
  networkMapContainer: {
    height: "100%",
    width: "100%",
    position: "relative",
    "& .react-flow__handle": {
      visibility: "hidden"
    }
  },
  networkMapContainerWrapper: {
    height: "800px",
    width: "900px",
    border: "1px solid #ccc",
    background: "#f7f7f7"
  },
  networkMapGroupNodeWrapper: {
    border: "1px solid #efefef",
    backgroundColor: "#ffffff",
    padding: "16px",
    display: "flex",
    alignItems: "start",
    justifyContent: "start",
    borderRadius: "8px"
  },
  networkMapNetworkNodeWrapper: {
    border: "1px solid #efefef",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    padding: "8px 12px",
    gap: "8px",
    position: "relative",
    cursor: "pointer"
  },
  networkNodeIconWrapper: {
    background: "#EBEBEB",
    color: "#EBEBEB",
    width: "24px",
    height: "24px",
    borderRadius: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  networkNodeWarningTooltip: {
    visibility: "hidden",
    width: "100%",
    backgroundColor: "#292B2F",
    color: "#F7F7F7",
    textAlign: "left",
    padding: "8px",
    borderRadius: "4px",
    fontWeight: "600",
    fontSize: "12px",
    lineHeight: "16px",
    boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)",
    /* MUI tooltip shadow */
    /* Position the tooltip text */
    position: "absolute",
    bottom: "120%",
    left: 0,
    opacity: 0,
    transition: "opacity 0.3s"
  },
  networkNodeWarningTooltipVisible: {
    visibility: "visible",
    opacity: 1
  },
  networkNodeWarningIconContainer: {
    position: "absolute",
    width: "12px",
    height: "12px",
    left: "20px",
    top: "50%"
  },
  networkNodeEndAdornment: {
    position: "absolute",
    right: "0px",
    top: "50%",
    translate: "100% -50%"
  },
  warningIcon: {
    fill: "#FFAF19",
    strokeWidth: 0
  },
  networkNodeHover: {
    border: "1px solid #C5C8CE",
    transition: "border 0.1s ease-out"
  },
  networkNodeSelected: {
    border: "1px solid #226A58",
    transition: "border 0.1s ease-out"
  },
  networkNodeOuterBox: {
    height: "52px",
    display: "flex",
    alignItems: "center",
    "& .animate-end-adornment": {
      transition: "all 0.3s ease-in-out"
    },
    "&:hover .animate-end-adornment": {
      transform: "translate(40%, 0)"
    }
  },
  nodeIcon: {
    width: 16,
    height: 16,
    fill: "#5B5B5B",
    strokeWidth: 0
  },
  controlsContainer: {
    pointerEvents: "all",
    position: "absolute",
    left: 0,
    bottom: 0,
    flexDirection: "column",
    boxShadow: "0 0 2px 1px rgba(0, 0, 0, 0.08)",
    margin: "16px",
    zIndex: 5,
    background: "white",
    width: "fit-content",
    "& > button": {
      width: "24px",
      height: "24px",
      color: "rgba(0, 0, 0, 0.87)",
      minWidth: 0,
      borderRadius: 0,
      "&:hover": {
        background: "#F4F4F4"
      }
    }
  }
};
export {
  o as styles
};
